import { FindCustomersOutput } from '../../../services/modules/customers/customers.types';
import { CustomerOriginType, CustomerSynchronizedStatus } from '../../customer/types/customer.enum';
import { Customer } from '../../customer/types/customer.types';
import { StoreStatusEnum } from '../../store-admin/store.types';
import { OfflineDatabaseCustomer } from '../database/offlineDatabase/types/offlineDatabaseCustomer.types';

export class OfflineCustomerTransformers {
  static toOnlineCustomer(customer: OfflineDatabaseCustomer): Customer {
    return {
      email: '',
      isPJ: false,
      createdAt: '',
      updatedAt: '',
      storeId: '',
      location: '',
      addresses: [],
      id: customer.id,
      storeVerified: true,
      code: customer.code,
      storeStatus: StoreStatusEnum.ACTIVE,
      customerGroupName: '',
      status: customer.status,
      salesRepresentatives: [],
      cpfcnpj: customer.cpfcnpj,
      companyName: customer.companyName,
      commercialName: customer.commercialName,
      synchronized: CustomerSynchronizedStatus.NOT_SYNCHRONIZED,
      origin: CustomerOriginType.MANUAL,
    };
  }

  static toFindCustomersOutput(customer: OfflineDatabaseCustomer): FindCustomersOutput['data'][0] {
    return {
      availableBalance: 0,
      createdAt: '',
      updatedAt: '',
      creditLimit: 0,
      id: customer.id,
      code: customer.code,
      status: customer.status,
      cpfcnpj: customer.cpfcnpj,
      companyName: customer.companyName,
      commercialName: customer.commercialName,
      addresses: [],
      storeStatus: StoreStatusEnum.ACTIVE,
      storeId: '',
      storeVerified: true,
      location: '',
      customerGroupName: '',
      email: '',
      isPJ: false,
      salesRepresentatives: [],
      synchronized: CustomerSynchronizedStatus.NOT_SYNCHRONIZED,
      origin: CustomerOriginType.MANUAL,
    };
  }
}
